import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { Router, ActivatedRoute } from '@angular/router';
import { EditOrganizationService } from '../edit-organization/edit-organization.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-show-organization',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './show-organization.component.html',
  styleUrl: './show-organization.component.scss'
})
export class ShowOrganizationComponent implements OnInit, OnDestroy {
  organizationId: string = '';
  organizationData: any = {};
  types: any[] = [];
  organizationTypeName: string = '';
  isLoading = false;
  serverError: any;
  showSuccess = false;
  private _alertTimeout: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private editOrganizationService: EditOrganizationService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.organizationId = params.get('id') || '';
      if (this.organizationId) {
        this.loadOrganizationData();
      }
    });

    // Check for success message from edit page
    this.route.queryParamMap.subscribe(queryParams => {
      if (queryParams.get('updated') === '1') {
        this.showSuccess = true;
        // Reload organization data to show updated values
        if (this.organizationId) {
          this.loadOrganizationData();
        }
        // Clear success message after 4 seconds
        this._alertTimeout = setTimeout(() => {
          this.showSuccess = false;
        }, 4000);
      }
    });
  }

  loadOrganizationData() {
    this.isLoading = true;
    const token = this.authService.token;
    
    // Load organization data and organization types in parallel
    this.editOrganizationService.getOrganization(this.organizationId, token).subscribe({
      next: (data) => {
        this.organizationData = data;
        this.loadOrganizationTypes(token);
      },
      error: (error) => {
        this.serverError = error;
        this.isLoading = false;
        
        // Clear error message after 4 seconds
        this._alertTimeout = setTimeout(() => {
          this.serverError = null;
        }, 4000);
      }
    });
  }

  loadOrganizationTypes(token: string) {
    this.editOrganizationService.getOrganizationTypes(token).subscribe({
      next: (data) => {
        this.types = data.organizationTypes;
        this.setOrganizationTypeName();
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load organization types:', err);
        this.isLoading = false;
      }
    });
  }

  setOrganizationTypeName() {
    if (this.organizationData.organizationTypeId && this.types.length > 0) {
      const orgType = this.types.find(type => type.orgTypeId === this.organizationData.organizationTypeId);
      this.organizationTypeName = orgType ? orgType.orgTypeName : this.organizationData.organizationTypeId;
    } else {
      this.organizationTypeName = this.organizationData.organizationTypeId || 'N/A';
    }
  }

  onEdit() {
    this.router.navigate(['/organization/edit-organization', this.organizationId]);
  }

  onBack() {
    this.router.navigate(['/organization']);
  }

  dismissAlert() {
    this.serverError = null;
    if (this._alertTimeout) {
      clearTimeout(this._alertTimeout);
      this._alertTimeout = null;
    }
  }

  dismissSuccessAlert() {
    this.showSuccess = false;
    if (this._alertTimeout) {
      clearTimeout(this._alertTimeout);
      this._alertTimeout = null;
    }
  }

  ngOnDestroy() {
    if (this._alertTimeout) {
      clearTimeout(this._alertTimeout);
    }
  }
}
